var d3 = require("d3");
var _ = require("lodash");
const {TIMEPARSER,
    TIMEFORMATTER,
    selectStep1ID,
    selectStep2ID,
    selectStep3ID,
    lineChartID,
    lineBtnID,
    svgLinesID,
    gLinesID,
    riLineID,
    nonRILineID,
    lineZeroID,
    heightLineChartDiv,
    widthLineChartDiv,
    paddingSVG,
    paddingScale,
    xScaleRange,
    yScaleRange,
    translate_xAxis,
    translate_yAxis,
    COLS,
    URL_RI,
    URL_nonRIMedian,
    URL_nonRIMean,
    colors,
    strokeWidth,
    yTickFormat,
    titles,
    titlesData,
    URL_STATES,
    URL_COUNTIES,
    URL_STATEGEOJSON,
    URL_COUNTYGEOJSON,
    URL_DATESET,
} = require('./constVars');

const modules = require("./modules");
let promiseRI = d3.csv(URL_RI);
let promiseNonRIMean = d3.csv(URL_nonRIMean);
let promiseNonRIMedian = d3.csv(URL_nonRIMedian);
let promiseGisStates = d3.json(URL_STATEGEOJSON);
let promiseGisCounties = d3.json(URL_COUNTYGEOJSON);
let promiseDateSet = d3.json(URL_DATESET);
let statesJSON, countiesJSON, countyIDs, stateIDs;
let dateRange_default = {
    startDate: '',
    endDate: ''
}

document.addEventListener("DOMContentLoaded", function (){

    //line Chart section
    modules.setDivDims();
    Promise.all([promiseRI, promiseNonRIMedian, promiseNonRIMean, promiseDateSet]).then((arr) =>{
        let dates=arr[3];
        let datesArr = dates['dates'];
        datesArr.sort((a,b)=>TIMEPARSER(a)-TIMEPARSER(b));
        let startDateDefault = moment(datesArr[0], "YYYY-MM-DD").format("MM/DD/YYYY");
        let endDateDefault = moment(datesArr[datesArr.length-1], "YYYY-MM-DD").format("MM/DD/YYYY");
        dateRange_default.startDate = datesArr[0];
        dateRange_default.endDate = datesArr[datesArr.length-1];

        $('input[name="daterange"]').daterangepicker({
            startDate: startDateDefault,
            endDate: endDateDefault,
            showDropdowns: false,
            minDate: startDateDefault,
            maxDate: endDateDefault,
            autoApply: true

        }, function(start, end, label){
            dateRange_default.startDate = start.format("YYYY-MM-DD");
            dateRange_default.endDate = end.format("YYYY-MM-DD")
        });
        modules.enableLineBtn();
        arr.slice(0,3).forEach(d=>{
            modules.str2NumAndDate(d)
        });
        let dRI_init = arr[0].map(el=>_.pick(el, ['date', COLS[0]]));
        modules.initAxes(dRI_init);

        d3.select(lineBtnID).on("click", function () {
            let select1 = d3.select(selectStep1ID).property('value');
            let select2 = d3.select(selectStep2ID).property('value');
            let select3 = d3.select(selectStep3ID).property("value");
            if (select1 === 'title' || select2 === 'title' || select3 === "title") {
                return alert("please select the data and dates first!");
            }
            let data;
            select3 === '0' ? data = arr.slice(0,3) : data = modules.getWKData(arr.slice(0,3));
            let col = COLS[+select2];
            let dRI = data[0].map(el=>_.pick(el, ['date', col]));
            dRI = dRI.filter(el=>el.date>=TIMEPARSER(dateRange_default.startDate) && el.date<=TIMEPARSER(dateRange_default.endDate));
            d3.select(gLinesID).remove(); //remove existing gLines including line-zero
            d3.select(svgLinesID).append("g").attr('id', `${_.trimStart(gLinesID, "#")}`); //add a new gLines


            switch (select1) {
                case '0'://RI only
                    modules.drawLines([dRI], col);
                    break;
                case '1': //RI + NonRI Median
                    let dNonRIMedian = data[1].map(el=>_.pick(el, ['date', col]));
                    dNonRIMedian = dNonRIMedian.filter(el=>el.date>=TIMEPARSER(dateRange_default.startDate) && el.date<=TIMEPARSER(dateRange_default.endDate));
                    modules.drawLines([dRI, dNonRIMedian], col);
                    break;
                case '2': //RI + NonRI Mean
                    let dNonRIMean = data[2].map(el=>_.pick(el, ['date',col]));
                    dNonRIMean = dNonRIMean.filter(el=>el.date>=TIMEPARSER(dateRange_default.startDate) && el.date<=TIMEPARSER(dateRange_default.endDate));
                    modules.drawLines( [dRI, dNonRIMean], col);
                    break;
            }

            modules.addTitle(select1, select2);
            modules.addLegend(select1);


        })


    } ).catch((err) =>{
        alert("Error happens while loading data. Please refresh the page or access later.")
    })
    //maps section
    promiseDateSet.then((dates) =>{
        //load select-date-state and select-date-county
        modules.loadDates(dates);
    } ).catch(err=>{console.log(err); return alert("Error loading dates info!")});

    Promise.all([promiseGisStates, promiseGisCounties]).then((arr) =>{
        statesJSON = arr[0];
        countiesJSON = arr[1];
        stateIDs = modules.getIDs(statesJSON, 'state');
        countyIDs = modules.getIDs(countiesJSON, 'county');
        modules.drawMap(statesJSON, "State");
        modules.drawMap(countiesJSON, "County");

    })
    d3.select('#renderState').on('click', event => {
        let date_selected = d3.select("#select-date-state").property('value');
        let col_selected = d3.select("#select-col-state").property('value');
        let var_selected = document.getElementById("select-col-state");
        let text_selected = var_selected.options[var_selected.selectedIndex].text;
        if (!modules.checkSels(date_selected, col_selected)){return alert("please select a date and variable first!")}
        d3.json(`${URL_STATES+date_selected+'@'+COLS[col_selected]}`).then((data) =>{
            //update map and legend
            //console.log(data);
            document.getElementById(`tooltipState`).style.opacity ="0";
            modules.changeMapStyle(data, "state", col_selected);
        }).catch((err) =>{
            alert("Error loading state data!");
        })
        //change tht title
        d3.select("#stateTitle").html(`${text_selected} Changes on ${date_selected} by State`);

    })
    d3.select("#renderCounty").on('click', event => {
        let date_selected = d3.select("#select-date-county").property('value');
        let col_selected = d3.select("#select-col-county").property('value');
        let var_selected = document.getElementById("select-col-county");
        let text_selected = var_selected.options[var_selected.selectedIndex].text;
        if (!modules.checkSels(date_selected, col_selected)){return alert("please select a date and variable first!")}
        d3.json(`${URL_COUNTIES+date_selected+'@'+COLS[col_selected]}`).then((data) =>{
            //update county map and legend
            document.getElementById(`tooltipCounty`).style.opacity ="0";
            modules.changeMapStyle(data, 'county', col_selected)

        }).catch((err) =>{
            alert("Error loading county data!");
        })
        //update the title
        d3.select("#countyTitle").html(`${text_selected} Changes on ${date_selected} by County`);
    })





})








